module.exports = {
  platform: 'voice',
  name: 'Page',
  node: 'page',
  bg: '#FFFFFF',
  note: '',
  property: {
    type: 'page', // page, pang_name
    page: '',
    is_custom_component: false,
    component: '',
    page_name: ''
  }
}
